/**
 * Phase 14c — operator notification preferences.
 *
 * Per-operator subscription to operator-facing notification templates.
 * Backs `GET /me/operator/notification-preferences` (catalog + current
 * subscription state) and `PATCH /me/operator/notification-preferences`
 * (bulk update).
 *
 * Replaces the single-mailbox `AuthConfig.operatorNotifyEmail` fan-out
 * for operator-facing templates. At v1 ship, the only operator-facing
 * template is `facility-lead-notify`; the catalog scales as more
 * operator-facing templates are added.
 */
import { z } from 'zod';
/** One row in the GET response: template metadata + the calling operator's
 *  current subscription state. */
export const OperatorNotificationPreferenceItemSchema = z.object({
    /** Stable template id (e.g., `facility-lead-notify`). */
    templateCodeName: z.string().min(1),
    /** Human-readable label rendered next to the checkbox. */
    label: z.string().min(1),
    /** One-sentence description shown under the label. */
    description: z.string().min(1),
    /** Current subscription state for the calling operator. */
    subscribed: z.boolean(),
});
export const OperatorNotificationPreferencesResponseSchema = z.object({
    preferences: z.array(OperatorNotificationPreferenceItemSchema),
});
/** PATCH body: array of (templateCodeName, subscribed) pairs. Only
 *  templates listed in the body are updated; omitted templates are
 *  unchanged. The endpoint validates every templateCodeName against the
 *  registered operator-facing template catalog and rejects unknowns. */
export const OperatorNotificationPreferencesPatchRequestSchema = z.object({
    updates: z
        .array(z.object({
        templateCodeName: z.string().min(1),
        subscribed: z.boolean(),
    }))
        .min(1)
        .max(50),
});
//# sourceMappingURL=notification-preferences.schema.js.map